import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type { BeniSmartCompset } from 'lumen/models';
import type HotelSettingsCompetitorsBenchmarkRoute from 'lumen/routes/hotel/settings/competitors/benchmark';
import type { BeniSmartCompsetCategoryWithWeight } from 'lumen/utils/constants/benchmark-insight/beni-smart-compset-constant-values';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkSmartCompsetReviewController extends Controller {
  declare model: ModelFrom<HotelSettingsCompetitorsBenchmarkRoute>;

  @service declare router: Services['router'];

  get enabledCategories(): BeniSmartCompsetCategoryWithWeight[] {
    return (
      this.smartCompset?.categories
        .filter(
          (category): category is BeniSmartCompsetCategoryWithWeight =>
            category.weight !== null,
        )
        .sort((a, b) => b.weight - a.weight) ?? []
    );
  }

  get smartCompset(): BeniSmartCompset | null {
    return this.model.smartCompset?.last?.value ?? null;
  }

  @action
  onBack(): void {
    this.router.transitionTo(
      'hotel.settings.competitors.benchmark.smart-compset.weights',
    );
  }

  @action
  onCloseModal(): void {
    this.router.transitionTo('hotel.settings.competitors.benchmark');
  }

  @action
  onContinue(): void {
    this.router.transitionTo(
      'hotel.settings.competitors.benchmark.smart-compset.validation',
    );
  }
}
